<template>
  <div>
    <b-card
      no-body
      class="p-2 container-card"
    >
      <b-row>
        <b-col
          cols="12"
          class="px-2"
        >
          <article-category-filter-header
            :activeAddButton="getPermissionModule('Article').adjust"
            :status-option="statusOption"
            :on-search-category="onSearchCategory"
            :on-select-filter="onSelectFilter"
          />
        </b-col>
        <b-col
          cols="12"
          class="mb-1"
        >
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :key="tableModeReorder + keyChange"
                v-sortable-row="sortableRowOptions"
                :fields="fields"
                :items="articleCategory.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table"
                :class="tableModeReorder ? 'table-reorder' : null"
                @sort-changed="sortingChanged"
              >
                <template #cell(category_active_img)="data">
                  <div v-if="data.item.category_active_img">
                    <img
                      :src="data.item.category_active_img"
                      class="article-category-image-column"
                      alt=""
                      draggable="false"
                    >
                  </div>
                  <div v-else>
                    -
                  </div>
                </template>
                <template #cell(category_inactive_img)="data">
                  <div v-if="data.item.category_inactive_img">
                    <img
                      :src="data.item.category_inactive_img"
                      class="article-category-image-column"
                      alt=""
                      draggable="false"
                    >
                  </div>
                  <div v-else>
                    -
                  </div>
                </template>
                <template #cell(valid_from)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.valid_from)
                  }}</span>
                </template>
                <template #cell(valid_through)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.valid_through)
                  }}</span>
                </template>
                <template #cell(status)="data">
                  <b-form-checkbox
                    v-if="getPermissionModule('Article').adjust"
                    field-value="true"
                    class="custom-control-success custom-toggle"
                    name="check-button"
                    switch
                    :checked="data.item.status == 1"
                    @change="onToggleStatus($event, data.item)"
                  >
                    <span class="switch-icon-left toggle-text">{{
                      'Active'
                    }}</span>
                    <span class="switch-icon-right toggle-text">{{
                      'InActive'
                    }}</span>
                  </b-form-checkbox>
                  <div v-else class="d-flex">
                    <span :style="data.item.status?'background-color:lightgreen;color:green;':'background-color:pink;color: red;'" style="padding: 5px 15px;border-radius: 18px;font-weight: bold;">{{ data.item.status?'Active':'Inactive' }}</span>
                  </div>
                </template>
                <template #cell(actions)="data">
                  <div v-if="getPermissionModule('Article').adjust" class="d-flex justify-content-center ">
                    <b-button
                      v-b-tooltip.hover
                      title="Edit"
                      variant="secondary"
                      class="default-btn-action mr-2"
                      @click="
                        $router.push(
                          `/article/article/category/${data.item.category_id}/info`,
                        )
                      "
                    >
                      <edit-icon class="article-action-svg iconEdit-btn" />
                    </b-button>
                    <b-button
                      v-b-tooltip.hover
                      title="Delete"
                      variant="secondary"
                      class="default-btn-action mr-2"
                      @click="handleDeleteModal(data.item.category_id)"
                    >
                      <delete-icon class="article-action-svg" />
                    </b-button>
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            reordering
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
            @reorder="handleTableReorder"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BTable,
  BFormCheckbox,
  BRow,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import EditIcon from '@/@core/components/svg/common/Edit.vue'
import DeleteIcon from '@/@core/components/svg/common/Trash.vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'

import Sortable from 'sortablejs'
import ArticleCategoryFilterHeader from './components/ArticleCategoryFilterHeader.vue'
import useArticleCategory from './hooks/useArticleCategory'

const createSortable = (el, options, vnode) => Sortable.create(el, {
  ...options,
})

const sortableRow = {
  name: 'sortableRow',
  bind(el, binding, vnode) {
    const table = el
    table._sortable = createSortable(
      table.querySelector('tbody'),
      binding.value,
      vnode,
    )
  },
}
export default {
  directives: {
    sortableRow,
  },
  components: {
    BCard,
    BCol,
    BFormCheckbox,
    BTable,
    BRow,
    BButton,
    BSpinner,
    EditIcon,
    DeleteIcon,
    CardNoItem,
    PaginationWithReorder,
    ArticleCategoryFilterHeader,
  },
  setup() {
    const {
      fields,
      loading,
      keyChange,
      articleCategory,
      statusOption,
      sortableRowOptions,
      tableModeReorder,
      pagination,
      ordering,
      onSelectFilter,
      onPageChange,
      onSearchCategory,
      onFilterEntity,
      sortingChanged,
      resolveDateWithSeperator,
      handleRowChange,
      handleTableReorder,
      handleDeleteModal,
      onToggleStatus,
      getPermissionModule
    } = useArticleCategory()
    return {
      fields,
      loading,
      keyChange,
      articleCategory,
      statusOption,
      sortableRowOptions,
      tableModeReorder,
      pagination,
      ordering,
      onSelectFilter,
      onPageChange,
      onSearchCategory,
      onFilterEntity,
      sortingChanged,
      resolveDateWithSeperator,
      handleRowChange,
      handleTableReorder,
      handleDeleteModal,
      onToggleStatus,
      getPermissionModule
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/pages/article/article-table-list.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
